export { default } from "./MenuButtonDinamic";
